export const UPDATE_REQUEST_QUEUE_LENGTH = 'update-request-queue-length';

export default function updateRequestQueueLength() {
  return {
    type: UPDATE_REQUEST_QUEUE_LENGTH,
  };
}
